import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router";
import { FormSection } from "./FormSection";
import { GoogleAnalyticsSettings } from "./GoogleAnalyticsSettings";
import { SearchConsoleSettings } from "./SearchConsoleSettings";

// Both connections are picked from the same list of Google accounts, so the page offers one way in
// to manage them rather than repeating it in every block.
const ManageLink = styled.button`
    align-self: flex-start;
    background: none;
    border: none;
    padding: 0;
    font-size: 0.78rem;
    font-weight: 600;
    color: #6366f1;
    cursor: pointer;
    font-family: "Inter", system-ui, sans-serif;
    &:hover { text-decoration: underline; }
`;

export const GoogleConnections = ({ currentWorkspace, busy, imported, setAnalyticsSettings, setSearchConsoleSettings }) => {
    const history = useHistory();

    return (
        <FormSection
            label="Google Settings"
            description="Which Google properties this workspace reads its traffic from. Changing one replaces the stored history with a year read back from the new property."
        >
            <GoogleAnalyticsSettings
                currentWorkspace={currentWorkspace}
                busyWith={busy.analytics}
                imported={imported.analytics}
                setAnalyticsSettings={setAnalyticsSettings}
            />
            <SearchConsoleSettings
                currentWorkspace={currentWorkspace}
                busyWith={busy.searchConsole}
                imported={imported.searchConsole}
                setSearchConsoleSettings={setSearchConsoleSettings}
            />
            <ManageLink onClick={() => history.push("/account/google-analytics")}>
                Manage Google accounts
            </ManageLink>
        </FormSection>
    );
};
